<template>
  <div class="account-item columns" v-if="!deleted">
    <div class="centered column delete-column">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="handleDelete"/>
    </div>
    <div class="column">
      <b-input
      v-model="account.email"
      placeholder="Введите email"
      :class="validation.email ? '': 'error'"
      @change="emailChanged"
      :disabled="!editMode" />
    </div>
    <div class="is-flex column">
      <form @submit="changePassword">
        <span class="link centered change-password"
          v-if="!passwordChangeMode"
          @click="toggleChangePassword">Сменить пароль</span>
        <div v-else>
          <b-field>
            <a class="delete hide-password-input" @click="toggleChangePassword" v-if="!account.isNew"></a>
            <b-input v-model="newPassword" placeholder="Новый пароль"
            ref:pass
            @change='passwordChanged'
            :class="validation.password ? '': 'error'" />
            <img src="/static/img/icons/apply.svg" class="is-medium apply-icon" @click="changePassword"  v-if="!account.isNew"/>
          </b-field>
        </div>
      </form>
    </div>
    <div class="column">
      <el-select v-model="role" placeholder="" :disabled="!editMode">
        <el-option
          v-for="role in roles"
          :key="role"
          :label="role"
          :value="role">
        </el-option>
      </el-select>
    </div>
    <div class="centered column edit edit-column">
      <img src="/static/img/icons/edit.svg" class="edit-icon" @click="toggleEdit" v-if="!editMode"/>
      <a class="button is-info" v-else @click="handleUpdateAccount">Сохранить</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AccountItem',
  data () {
    return {
      editMode: false,
      passwordChangeMode: false,
      role: '',
      newPassword: '',
      deleted: false,
      validation: {
        email: false,
        password: false
      }
    }
  },
  created () {
    this.role = this.account.role
    if (this.account.isNew) {
      this.editMode = true
      this.passwordChangeMode = true
    }
  },
  props: {
    account: {
      required: true
    },
    roles: {
      required: true
    }
  },
  methods: {
    ...mapActions(['deleteAccount', 'addAccount', 'updateAccount']),
    toggleEdit () {
      this.emailChanged()
      this.passwordChanged()
      this.editMode = !this.editMode
    },
    toggleChangePassword () {
      this.passwordChangeMode = !this.passwordChangeMode
    },
    emailChanged () {
      const emailRE = /\S+@\S+\.\S+/
      this.validation.email = emailRE.test(this.account.email)
    },
    passwordChanged () {
      this.validation.password = this.newPassword.length !== 0
    },
    handleDelete () {
      if (!this.account.isNew) {
        this.deleteAccount(this.account.id)
      }
      this.deleted = true
    },
    changePassword (e) {
      this.account.password = this.newPassword
      this.updateAccount(this.account)
      this.toggleChangePassword()
      e.preventDefault()
    },
    handleUpdateAccount () {
      if (this.validation.email) {
        this.account.role = this.role
        if (this.account.isNew) {
          this.account.password = this.newPassword
          this.addAccount(this.account)
        } else {
          if (this.newPassword) {
            this.account.password = this.newPassword
            this.created = true
          }
          this.updateAccount(this.account)
        }
        this.passwordChangeMode = false
        this.toggleEdit()
      }
    }
  }
}
</script>

<style scoped>
.account-item {
  background: #eee;
  margin: 5px 0;
  padding: 10px;
  border-radius: 5px;
}
.delete-icon {
  position: initial;
}
img {
  height: 32px;
  width: 32px;
  margin: 0 8px;
  vertical-align: text-top;
}
.change-password {
  padding: 5px 15px;
}
.column {
  padding: 0;
}
.edit-icon {
  cursor: pointer;
  float: right;
}
.delete-column {
  max-width: 60px;
}
.edit-column {
    max-width: 110px;
}
.link {
  text-align: left;
  display: inline-block;
}
.control {
  margin-right: 15px;
}
.apply-icon {
  background: #006DF0;
  border-radius: 25px;
  padding: 5px;
  cursor: pointer;
}
.hide-password-input {
  height: 32px;
  min-width: 32px;
  margin: 0 8px 0 0;
}
form {
  margin: 0 15px 0 0;
}
</style>
<style>
.account-item input:disabled,
.is-disabled input{
  background: #eee !important;
  border: none !important;
  color: #000 !important;
}
.is-disabled .el-icon-caret-top {
  display: none;
}
.account-item .error input {
  border-color: red !important;
}
</style>



// WEBPACK FOOTER //
// AccountItem.vue?4fce49ab